import styled, { css } from 'styled-components'

export const Footer = styled.div(
  ({ theme }) => css`
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    gap: ${theme.space['16']};
  `,
)

export const RightSection = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: ${theme.space['12']};
  `,
)

export const SelectWrapper = styled.div(
  () => css`
    width: 12rem;
  `,
)

export const Controls = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${theme.space['8']};
  `,
)
